import React from 'react';
import { Linkedin } from 'lucide-react';

const MeetFounders = () => {
  const founders = [
    {
      name: "Ciara Wiese",
      expertise: "Hospitality Operations & Specialist Recruitment",
      credentials: [
        "EU, GCC and South African markets",
        "10 years in hospitality operations"
      ],
      image: "/founders/ciara-wiese.jpg",
      alt: "Ciara Wiese, co-founder of YuZu Recruitment Services",
      paragraph: "Ciara spent close to ten years inside hospitality, working up from VVIP waitress and hostess to food and beverage team leader and then assistant restaurant manager, across South Africa, the Middle East and Europe. That floor experience means she understands how service teams actually function under pressure, and what separates someone who copes from someone who does not. She also brings specialist recruitment experience across the EU, GCC and South African hospitality markets.",
      linkedin: "https://www.linkedin.com/in/ciara-wiese-911bb218b/"
    },
    {
      name: "Marché van Deventer",
      expertise: "Psychology & Behavioural Insight",
      credentials: [
        "Bachelor of Applied Social Science, majoring in Counselling and Psychology"
      ],
      image: "/founders/marche-van-deventer.jpg",
      alt: "Marché van Deventer, co-founder of YuZu Recruitment Services",
      paragraph: "Marché holds a Bachelor of Applied Social Science majoring in Counselling and Psychology. His expertise is in behaviour: how people respond under pressure, where accountability holds or breaks down, and what a work history really says about consistency. It is behavioural insight applied to hiring, not psychometric testing.",
      linkedin: "https://www.linkedin.com/in/march%C3%A9-van-deventer-912491195"
    }
  ];

  return (
    <section className="py-20 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-normal text-black mb-6" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased' }}>
            Meet the Founders
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" style={{ fontFamily: "'DM Serif Display', serif" }}>
            Ten years inside hospitality operations, and a psychology background for everything a CV does not show.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {founders.map((founder, index) => (
            <div 
              key={index}
              className="bg-white border border-gray-200 rounded-lg p-8 hover:border-[#FFD000] transition-all duration-300"
            >
              <div className="flex flex-col items-center text-center mb-6">
                {/* Founder Headshot */}
                <img
                  src={founder.image}
                  alt={founder.alt}
                  width="240"
                  height="240"
                  loading="lazy"
                  data-testid={`founder-photo-${index}`}
                  className="w-36 h-36 sm:w-44 sm:h-44 lg:w-[220px] lg:h-[220px] rounded-full mb-6 border border-gray-200"
                  style={{ objectFit: 'cover', objectPosition: 'center' }}
                />
                
                {/* Name */}
                <h3 className="text-xl font-semibold text-black mb-1">
                  {founder.name}
                </h3>
                
                {/* Expertise Line */}
                <p className="text-[#FFD000] font-medium mb-3">
                  {founder.expertise}
                </p>
                
                {/* Credentials */}
                <div className="space-y-1 mb-4">
                  {founder.credentials.map((credential, credIndex) => (
                    <p key={credIndex} className="text-xs text-gray-600 leading-relaxed">
                      {credential}
                    </p>
                  ))}
                </div>
              </div>
              
              {/* Paragraph */}
              <p className="text-gray-700 text-sm leading-relaxed mb-6">
                {founder.paragraph}
              </p>
              
              {/* LinkedIn Link */}
              <div className="flex justify-center">
                <a 
                  href={founder.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-sm text-gray-500 hover:text-[#FFD000] transition-colors duration-200"
                >
                  <Linkedin className="h-4 w-4 mr-2" />
                  LinkedIn Profile
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MeetFounders;
